// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'vuetify/dist/vuetify.min.css'

import 'babel-polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify'
// import VueFire from 'vuefire'
import VueI18n from 'vue-i18n'
import { LANG_THEMES } from '@/constants'

import App from './App'
import router from './router'
import store from './store'
// import firebase from './firebase'

Vue.config.productionTip = false

Vue.use(Vuetify, {
  theme: LANG_THEMES.en
})

// Vue.use(VueFire)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: store.getters.userLanguage,
  fallbackLocale: 'en',
  messages: {},
  silentTranslationWarn: true
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  // firebase,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js